<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list class="use-gift-card-section">
    <ion-item>
      <ion-label class="Textresized">{{ 'Checkout.UseGiftCard' | translate }}</ion-label>
      <span class="Textresized">{{ useGiftCardToggleText | translate }}</span>
      <ion-toggle style="padding: 5px; max-width: 31px;" #useGiftCard formControlName="use" color="primary" (ionChange)="onUseGiftCardChange($event)">
      </ion-toggle>
    </ion-item>

    @if(useGiftCard.checked) {
      <ion-item>
        <ion-input formControlName="giftCard" placeholder="{{ 'Checkout.GiftCardNumber' | translate }}" (ionChange)="onGiftCardNumberChange()" class="Textresized adjustMinHeight" style="background: whitesmoke;border: 1px solid lightgrey;"></ion-input>
        <ion-input formControlName="cvn" placeholder="{{ 'CreditCard.Cvn' | translate }}" (ionChange)="onGiftCardNumberChange()" class="Textresized adjustMinHeight" style="background: whitesmoke;border: 1px solid lightgrey; max-width: 50px; margin-left: 5px;"></ion-input>
        <ion-button (click)="giftCardPreAuthorization()">{{ 'Checkout.ValidateGiftCard' | translate }}</ion-button>
      </ion-item>
    }
    
    @if (useGiftCard.checked && (giftCardValidate || giftCardError)) {
      <ion-item>
        <ion-label [style.color]="giftCardError ? 'red' : 'black'">{{ giftCardMessage }}</ion-label>
        <ion-label style="text-align: right;" [hidden]="!giftCardValidate">-{{ giftAmount | currency }}</ion-label>
      </ion-item>
    }
    @if (useGiftCard.checked && giftCardValidate) {
      <ion-item>
        <ion-label style="font-weight: bold; color:green;">{{ giftCardPaymentMessage | translate }}</ion-label>
        <ion-label style="text-align: right;font-weight: bold;">{{ remainingBalance | currency }}</ion-label>
      </ion-item>
    }
  </ion-list>
</form>